module.exports = __webpack_public_path__ + "img/info.045481b1.svg";